import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'
import {TicketStates} from '../../enumerations'
import Tooltip from '@mui/material/Tooltip';
import styled from 'styled-components';


const ClickableText = styled.span`
  color: blue;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

class Ticket extends Component {

  state = {
    type: 0,
    message: "",
    hidden_field: "",
    creator: 0,
    state: 0,
    published_at: "",
    createdAt: 0,
    updatedAt: ""
  }

//   let state = switch(state.state) {
//     | `Crash` => "Crash"
//     | `UnexpectedBehaviour`
//     | `MissingFunction`
//     | `Feedback`
//    }

//    let type = switch(state.type) {
//     | `OPEN => "open"
//     | `CLOSED => "close"
//     | `MERGED` => "merged"
//    }



  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    if(props.ticket !== undefined) {
        this.state = props.ticket;
    }
    this.cleanState  = this.cleanState.bind(this)
  }

  onCopy(email) {
    navigator.clipboard.writeText(email)
    alert('E-mail of user copied') 
  };
  
  cleanState() {
    this.setState({
        type: 0,
        message: "",
        hidden_field: "",
        creator: 0,
        state: 0,
        published_at: "",
        createdAt: 0,
        updatedAt: ""
    })
  }

  formatDate(date) {
    return new Intl.DateTimeFormat("de-DE", {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
    //     hour:  "2-digit",
    //     minute: "2-digit",
    //    second: "2-digit"
    }).format(new Date(date))
  }

  handleChange(e) {
    this.setState({state: e.target.value})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    let elements = React.Children.toArray(this.props.children)
    let updateButton = React.cloneElement(elements[0], {id: this.props.ticket.id, state: this.state, cleanState: this.cleanState})
    return (
        <tr>
            <td>{this.state.id}</td>
            <td>{this.state.type}</td>
            <td>{this.state.message.split('\n').map((value, index) => {
                return (
                <span key={index}>
                    {value}
                    <br />
                </span>
                )})}</td> 
            <td>{this.state.hidden_field !== undefined ? this.state.hidden_field.split('\n').map((value, index) => {
                return (
                <span key={index}>
                    {value}
                    <br />
                </span>
                )}) : ""}</td>
            <td>{this.formatDate(this.state.createdAt)}</td>
            <td><Tooltip title="Copy creator e-mail">
                    <ClickableText  
                    onClick={() => this.onCopy(this.state.creator.email)}>{this.state.creator?.username}</ClickableText >
              </Tooltip></td>
            <td>{token && !this.props.locked && this.props.ticket !== undefined ? 
            
            <select value={this.state.state} 
            onChange={(e) => {this.handleChange(e)}}>{
                Object.keys(TicketStates).map(key => (
                <option key={key} value={key}>{TicketStates[key]}</option>
                ))
            }</select> : this.state.state}</td>
            <td>{this.formatDate(this.state.updatedAt)}</td>
            {token && !this.props.locked && this.props.ticket !== undefined  && updateButton !== undefined &&
            <td>{ updateButton }</td>}
        </tr>
        )
    } 

}

export default Ticket